export const types = {
  SET_COMPANYNAME: 'SET_COMPANYNAME',
  SET_NIP: 'SET_NIP',
  SET_LEGALFORM: 'SET_LEGALFORM',
  SET_INDUSTRY: 'SET_INDUSTRY',
  SET_STREET: 'SET_STREET',
  SET_STREETNUMBER: 'SET_STREETNUMBER',
  SET_LOCALNUMBER: 'SET_LOCALNUMBER',
  SET_CITY: 'SET_CITY',
  SET_ZIPCODE: 'SET_ZIPCODE',
  SET_COMPANYPHONE: 'SET_COMPANYPHONE',
  SET_STATE: 'SET_STATE',
  HYDRATE: 'HYDRATE',
};
